import RestaurantSource from '../data/restaurant-source'
import { RestaurantReviewTemplate } from '../views/templates/template-creator'

const ModalInitiator = {
  async init ({ modal, showModalButton, hideModalButton, id }) {
    this._modal = modal
    this._showModalButton = showModalButton
    this._hideModalButton = hideModalButton
    this._id = id

    await this._renderModal()
  },

  async _renderModal () {
    const modal = document.getElementsByClassName('modal')
    const showModal = document.getElementsByClassName('show')
    const hideModal = document.getElementsByClassName('hide')

    hideModal[0].addEventListener('click', () => {
      modal[0].classList.remove('open-modal')
    })

    showModal[0].addEventListener('click', () => {
      modal[0].classList.add('open-modal')
    })

    const button = document.querySelector('.btn')
    button.addEventListener('click', async () => {
      const message = await this._save()

      if (message === 'success') {
        modal[0].classList.remove('open-modal')
      }

      const loader = document.querySelector('.backdrop')
      loader.style.display = 'none'
    })
  },

  async _save () {
    const loader = document.querySelector('.backdrop')
    loader.style.display = 'block'

    const id = this._id
    const fullName = document.querySelector('#fullName')
    const customerReview = document.querySelector('#customerReview')

    const data = JSON.stringify({
      id,
      name: fullName.value,
      review: customerReview.value
    })

    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    const date = new Date()

    const reviewContainer = document.querySelector('.review-container')
    reviewContainer.innerHTML += RestaurantReviewTemplate({
      name: fullName.value,
      date: date.toLocaleDateString('id-ID', options),
      review: customerReview.value
    })

    const reviewCount = document.querySelector('.review-count')
    const count = reviewCount.innerHTML.replace('(', '').split(' ')
    const res = parseInt(count[0]) + 1
    reviewCount.innerHTML = `(${res} Review)`

    const response = await RestaurantSource.postReview(data)
    return response.message
  }
}

export default ModalInitiator
